import { render, staticRenderFns } from "./shipTrack.vue?vue&type=template&id=20e8b3cf&"
import script from "./shipTrack.vue?vue&type=script&lang=js&"
export * from "./shipTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports